import styled, { css } from "styled-components";
import { space } from "styled-system";

const DefaultBadgeStyles = css`
    display: inline-block;
    padding: 4px 9px;
    font-size: 1.3rem;
    background: transparent;
    border-radius: 4px;
`;

const ButtonActiveStyles = css`
    color: ${({ theme }) => theme.color.lightest};
    background: ${({ theme }) => theme.color.primary};
`;

const ButtonLightestActiveStyles = css`
    color: ${({ theme }) => theme.color.grey5};
    background: ${({ theme }) => theme.color.lightest};
`;

const Badge = styled.div<{ fill: boolean; small: boolean }>`
    ${DefaultBadgeStyles};
    color: ${({ theme, fill }) => (fill ? theme.color.lightest : theme.color.primary)};
    border: 1px solid ${({ theme }) => theme.color.primary};
    ${space}
    ${({ fill, theme }) =>
        fill &&
        css`
            background: ${theme.color.primary};
        `}

    ${({ small }) =>
        small &&
        css`
            padding: 0px 6px;
        `}
`;

export const Lightest = styled(Badge)<{ fill: boolean }>`
    color: ${({ theme, fill }) => (fill ? theme.color.grey5 : theme.color.lightest)};
    border-color: ${({ theme }) => theme.color.lightest};

    ${({ fill, theme }) =>
        fill &&
        css`
            background: ${theme.color.lightest};
        `};
`;

export const Button = styled.button<{ active: boolean }>`
    ${DefaultBadgeStyles};
    color: ${({ theme }) => theme.color.primary};
    border: 1px solid ${({ theme }) => theme.color.primary};
    ${space};
    transition:
        color 0.24s,
        background 0.24s;
    &:hover,
    &:active {
        ${ButtonActiveStyles};
    }
    ${({ active }) => active && ButtonActiveStyles};
`;

export const ButtonLightest = styled(Button)<{ active: boolean }>`
    color: ${({ theme }) => theme.color.lightest};
    border: 1px solid ${({ theme }) => theme.color.lightest};
    &:hover,
    &:active {
        ${ButtonLightestActiveStyles};
    }
    ${({ active }) => active && ButtonLightestActiveStyles};
`;

export const EcoBadge = styled.div<{ imageUrl: string }>`
    width: 33px;
    height: 33px;
    min-height: 33px;
    background-image: ${({ imageUrl: src }) => `url('${src}')`};
    background-size: 33px 33px;
`;

export default Badge;
